import {
  API_ROUTES,
  mileageLogSchema,
  vehicleYearSchema,
  type AddMileageRequest,
  type SaveVehicleRequest,
} from '@hvac/contracts';
import { queryOptions } from '@tanstack/react-query';
import { z } from 'zod';
import { apiClient } from './queries.js';

export const vehicleKeys = {
  all: (organizationId: string) => ['vehicles', organizationId] as const,
};

export const vehiclesQuery = (organizationId: string, fiscalYear: number) =>
  queryOptions({
    queryKey: ['vehicles', organizationId, 'year', fiscalYear] as const,
    queryFn: ({ signal }) =>
      apiClient.request({
        path: `${API_ROUTES.vehicles.list(organizationId)}?fiscalYear=${String(fiscalYear)}`,
        schema: z.array(vehicleYearSchema),
        signal,
      }),
    staleTime: 15_000,
  });

export const mileageQuery = (organizationId: string, fiscalYear: number) =>
  queryOptions({
    queryKey: ['vehicles', organizationId, 'mileage', fiscalYear] as const,
    queryFn: ({ signal }) =>
      apiClient.request({
        path: `${API_ROUTES.vehicles.mileage(organizationId)}?fiscalYear=${String(fiscalYear)}`,
        schema: z.array(mileageLogSchema),
        signal,
      }),
    staleTime: 15_000,
  });

export const saveVehicle = (organizationId: string, body: SaveVehicleRequest) =>
  apiClient.request({
    method: 'POST',
    path: API_ROUTES.vehicles.list(organizationId),
    schema: z.object({ vehicleId: z.string() }),
    body,
  });

export const archiveVehicle = (organizationId: string, vehicleId: string) =>
  apiClient.request({
    method: 'POST',
    path: API_ROUTES.vehicles.archive(organizationId, vehicleId),
    schema: z.undefined(),
  });

export const addMileage = (organizationId: string, body: AddMileageRequest) =>
  apiClient.request({
    method: 'POST',
    path: API_ROUTES.vehicles.mileage(organizationId),
    schema: z.object({ logId: z.string() }),
    body,
  });

export const removeMileage = (organizationId: string, logId: string) =>
  apiClient.request({
    method: 'DELETE',
    path: API_ROUTES.vehicles.mileageEntry(organizationId, logId),
    schema: z.undefined(),
  });

export const postVehicleAdjustment = (organizationId: string, fiscalYear: number) =>
  apiClient.request({
    method: 'POST',
    path: API_ROUTES.vehicles.postAdjustment(organizationId),
    schema: z.object({ entryId: z.string().nullable() }),
    body: { fiscalYear },
  });
